import { useState, useEffect } from "react";

interface ScrollHook {
    scrollX: number;
    scrollY: number;
}

/**
 * useScroll React custom hook
 * Usage:
 *    const { scrollX, scrollY } = useScroll()
 */
const useScroll = (): ScrollHook => {
    const [scrollY, setScrollY] = useState(window.scrollY);
    const [scrollX, setScrollX] = useState(window.scrollX);

    const listener = () => {
        setScrollY(window.scrollY);
        setScrollX(window.scrollX);
    };

    useEffect(() => {
        window.addEventListener("scroll", listener);
        return () => {
            window.removeEventListener("scroll", listener);
        };
    }, []);

    return {
        scrollY,
        scrollX,
    };
};

export default useScroll;
